import React, {Component} from 'react';
import Avatar from 'material-ui/Avatar';
import Popover from 'material-ui/Popover';
import {FlatButton} from 'material-ui';

import packageJson from '../../package.json';

console.log(packageJson.version);

const style = {
    avatar: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: 10,
        cursor: 'pointer'
    },
    popover: {
        textAlign: 'center',
        width: 150,
        padding: '10px 0'
    }
};

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    openPopover(event) {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    }

    closePopover() {
        this.setState({
            open: false,
        });
    };

    render() {
        let avatarSrc = this.props.avatar;
        let avatar = null;
        let popover = null;


        if (avatarSrc) {
            avatarSrc = avatarSrc.replace(/^http:\/\//i, '//');
            avatar = <Avatar onTouchTap={this.openPopover.bind(this)} size={30} src={avatarSrc} style={style.avatar}/>;
            popover = <Popover style={style.popover}
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                targetOrigin={{horizontal: 'left', vertical: 'top'}}
                onRequestClose={this.closePopover.bind(this)}>
                <FlatButton primary={true} label="LOGOUT" onTouchTap={this.props.logout}/>
                <div><small>version {packageJson.version}</small></div>
            </Popover>;

        }

        return <header>{this.props.children}{avatar}{popover}</header>
    }

}

export default Header;